// @ts-nocheck
import { h } from "preact";
import { Modal } from "antd";
import {
  useEffect,
  useState,
  useImperativeHandle,
  useMemo,
} from "preact/hooks";
import { forwardRef } from "react";
import { useForm, useWatch } from "react-hook-form";
import BaseForm from "../../../../components/form";
import { Text } from "../../../../components/text";
import { useMessage } from "../../../../hooks/useMessage";
import { PUT, UPDATE_DEVICE } from "../../../../services";
import { FORM_EDIT_DATA } from "../../constants/forms";
import { DEFAULT_STATE } from "../../constants/defaultValue";
import { IPropsModal } from "../../interfaces/modal";
import moment from "moment";

const EditData = (props: any, ref) => {
  const { onCallBackModalEdit, options } = props;
  const { openMessage } = useMessage();
  const [visible, setVisible] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [isAvailableOrig, setIsAvailableOrig] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(false);
  const { control, setValue, getValues, reset, handleSubmit } = useForm({
    defaultValues: DEFAULT_STATE,
  });
  const customerCodeValue = useWatch({ control, name: "customerCode" });

  useEffect(() => {
    !visible && reset();
  }, [visible]);

  useEffect(() => {
    const hasCustomerCode = !!(
      customerCodeValue && String(customerCodeValue).trim()
    );
  }, [customerCodeValue]);

  useImperativeHandle(ref, () => ({
    async openModal(e: any) {
      try {
        setDeviceId(e.deviceID);
        setIsAvailableOrig(e.isAvailable ?? null);
        for (const key in e) {
          let element = e[key];
          if (key in DEFAULT_STATE) {
            if (key === "lotMonth" && element) {
              element = moment(element);
            }
            if (key === "isAvailable" && element != null) {
              element = !!element;
            }
            setValue(key as keyof typeof DEFAULT_STATE, element);
          }
        }
        setVisible(true);
      } catch (error) {
        console.log(error);
      }
    },
  }));

  const onConfirm = async (values) => {
    try {
      setLoading(true);
      const {
        remark,
        bluetooth,
        deviceStatusId,
        proxy,
        customerCode,
        lotMonth,
      } = values;
      const res = await PUT(UPDATE_DEVICE(deviceId), {
        remark,
        bluetooth,
        statusName: deviceStatusId,
        proxy,
        customerCode,
        isAvailable: isAvailableOrig,
        lotMonth: lotMonth ? moment(lotMonth).format("YYYY/MM") : null,
      });
      if (!res.success) {
        return;
      }
      setLoading(false);
      openMessage("success", res.message);
      onCallBackModalEdit && onCallBackModalEdit(getValues());
      setVisible(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", (error as Error).message);
    }
  };

  const forms = useMemo(() => {
    return FORM_EDIT_DATA({ options, customerCode: customerCodeValue });
  }, [options, customerCodeValue]);

  return (
    visible && (
      <Modal
        centered
        width={650}
        title={
          (
            <Text size={"L"} text={`แก้ไขข้อมูล #${deviceId}`} bold />
          ) as React.ReactNode
        }
        visible={visible}
        okText={"บันทึก"}
        cancelText={"ยกเลิก"}
        confirmLoading={loading}
        onCancel={() => setVisible(false)}
        onOk={handleSubmit(onConfirm)}
      >
        <BaseForm
          control={control}
          forms={forms}
          setValue={setValue}
          getValues={getValues}
        />
      </Modal>
    )
  );
};

export const ModalEditData = forwardRef<any, IPropsModal>(EditData);
